<template>
  <div>
    <!--<h4>D953654</h4>-->
  </div>
</template>

<script setup lang="ts">

// WsConnect742
import { DATA_0_ID, DATA_10_ID, DATA_1_ID, DATA_2_ID } from '@/pshared/common';
import { END_CONNECTION, ENDPOINT_742_, ENDPOINT_755_, INIT_CONNECTION, LEGACY_SENDER, WS_ON_APP } from '@/pshared/constants';
import { bResponse, cuser, host } from '@/store/store';
import type { CustomDetail } from '@/types/backendevent';
import type { DeviceData } from '@/types/devicedata';
import type { WSMessage } from '@/types/wsmessage';
import { onMounted, onUnmounted, ref, watch } from 'vue';


const LOG_INCOMING = false

const LOG_RECEIVE_MESG = false

const CMD_REMOTEA = "dremotea"; //alpha
const CMD_REMOTE = "dremote"; //numeric

let websocket: WebSocket
let connect_d = false
let wsError_ = false

let cntr = 0
//const wsmesgs_ = ref<WSMessage[]>([]);
const recordMessages_ = false //ref(false)

const bwmesg = ref("");

let messgcnt = 0

function parseMesgws755(messag: string) {
  const m: any = JSON.parse(messag);
  console.log(`###_NU_NU_##### 74563 ws ${ENDPOINT_755_} message:  ${m.content}`) //message from user
  //addAllMessages(m);
}

function receivesws755(message: string) {
  try {
    const r: CustomDetail = JSON.parse(message)
    //Object.assign(bResponse, r)
    if (message.includes("content")) {
      parseMesgws755(message);
    }
  } catch (error) {
    console.log(`parse error for ${message}`);
    recordMessage(`parse error for ${message}`)
  }
}

/*
{
  "type": "List",
  "data": "d908_798_klkgr_ht875",
  "clazz": "DeviceData[]",
  "key": null,
  "recipient": "N_08D82240",
  "sender": null,
  "value": [
    {
      "id": 170532,
      "time": "2025-05-10T16:40:10.334945691Z",
      "ownerId": "284",
      "deviceId": "FF",
      "deviceType": 0,
      "annotation": "",
      "dataName": "rweight",
      "attachment": "",
      "nature": "iot",
      "hvalue": 0.035,
      "version": "v1.1.3"
    }
  ]
}
*/

function parseDeviceData(message: string) {
  console.log(`receiveStandardMessages MESSAGE(${messgcnt++}) ${message}`)
  if (message.includes("\"clazz\":\"DeviceData[]\"")) {
    const r: CustomDetail = JSON.parse(message)
    const val = r.value
    const vluz: DeviceData[] = val
    vluz.forEach(deviceData => {
      console.log(deviceData.deviceId)
    });
  }
  const r: CustomDetail = JSON.parse(message)
  if (r.data && r.data == DATA_1_ID) {
    //r.id = r.recipient
    console.log(`receiveStandardMessages PARSED(${messgcnt++}) ${r.recipient}`)
  }
}



function receiveStandardMessages_old(message: string): boolean {
  if (LOG_RECEIVE_MESG) {
    try {
      parseDeviceData(message)
    } catch (error) {
      console.log(`in parseDeviceData error ${error} in [${message}]`)
    }
  }

  try {
    Object.assign(bResponse, JSON.parse(message))
    if (recordMessages_)
      recordMessage(message);
    return true
  } catch (error) {
    console.log(`in receiveStandardMessages error ${error} in [${message}]`)
    recordMessage(`in receiveStandardMessages error ${error} in [${message}]`)
  }
  return false
}

function logStandardMessage(message: string) {
  if (LOG_RECEIVE_MESG) {
    try {
      parseDeviceData(message)
    } catch (error) {
      console.log(`in parseDeviceData error ${error} in [${message}]`)
    }
  }
}



function receiveStandardMessages(message: string): boolean {
  const isStandard = message.includes(`${DATA_0_ID}`) || message.includes(`${DATA_10_ID}`) || message.includes(`${DATA_1_ID}`) || message.includes(`${DATA_2_ID}`)
  if (isStandard) {
    logStandardMessage(message)
    try {
      Object.assign(bResponse, JSON.parse(message))
      if (recordMessages_)
        recordMessage(message);
      return true
    } catch (error) {
      const lgr = `in receiveStandardMessages error ${error} in [${message}]`
      console.log(lgr)
      recordMessage(lgr)
    }
  }
  return false
}


/*
'{
"content":"weight = 0.037000",
"cmd":null,
"sender":"sim_ul",
"recipient":"all"}'
*/
function receiveCustomMessage(message: string): boolean {
  if (LOG_RECEIVE_MESG) {
    console.log(`receiveCustomMessage MESSAGE(${messgcnt++}) ${message}`)
  }
  if (message.startsWith('{"points":[{')) {
    try {
      const r: CustomDetail = {
        type: '',
        data: 'receive',
        value: message
      }
      Object.assign(bResponse, r)
      //bResponse=r   //before change CustomDetail
      if (recordMessages_)
        recordMessage(message);
      return true
    } catch (error) {
      console.log(`in receiveCustomMessage error${error} in [${message}]`)
      recordMessage(`in receiveCustomMessage error${error} in [${message}]`)
    }
  }
  return false
}


function wsready() {
  const r = websocket && connect_d && websocket.readyState == 1
  if (!r) {
    console.log("websocket not ready")
    recordMessage("websocket not ready")
  }
  return r
}

function sendmessg() {
  var data = JSON.stringify({
    mesg: bwmesg.value,
    usr: cuser.login
  });
  if (wsready()) {
    console.log(`send ws message ${data}`)
    websocket.send(data);
    bwmesg.value = "";
  } else {
    alert("no websocket");
  }
}

function sendUser() {
  var data = JSON.stringify({
    usr: cuser.login
  });
  if (wsready()) {
    console.log(`send ws message ${data}`)
    websocket.send(data);
  } else {
    alert("no websocket");
  }
}

function registerUser() {
  bwmesg.value = INIT_CONNECTION
  sendmessg()
}

function unRegisterUser() {
  bwmesg.value = END_CONNECTION
  sendmessg()
}

function register(c: boolean) {
  if (c) {
    registerUser()
  } else {
    unRegisterUser()
  }
}

function send(mesg: string) {
  var data = JSON.stringify({
    user: mesg
  })
  if (websocket != undefined) {
    try {
      websocket.send(data)
    } catch (error) {
      //lines.value.push('ws error')
      console.log(`ws failed send ${error}`)
      recordMessage(`ws failed send ${error}`)
    }
  } else {
    //  lines.value.push('no websocket')
    alert("no websocket");
  }
}

function doJoin742() {
  const url_ws742 = `${host.ws}/${ENDPOINT_742_}`
  console.log(`try connect ws742 to ${url_ws742}`);

  try {
    websocket = new WebSocket(url_ws742);
  } catch (error) {
    // websocket = undefined
    console.log(`ws failed ${url_ws742} ${error}`)
    recordMessage(`ws failed ${url_ws742} ${error}`)
    return
  }

  websocket.onopen = function () {
    console.log(`6438 Connected to endpoint ${url_ws742}`);
    send('helo')
    setConnected(true)
    setJoined(true);

    setTimeout(() => {
      register(true);
    }, 300);
  };



  function filterMessage(message: string): boolean {
    // if (message.includes("identified dremotea[")) {
    if (message.includes(CMD_REMOTEA)) {
      return true
    } else {
      return false
    }
  }

  function handleParseError(mesg: string) {
    const lgr = `WS parse error for [${mesg}]`
    console.log(lgr)
    recordMessage(lgr)
  }

  const WS_ACTIVE = true

  websocket.onmessage = function (mesg: any) {
    //let message = JSON.parse(payload.body);
    if (LOG_INCOMING) {
      console.log(`ws mesg ${mesg.data}`)
      //ws mesg identified dremotea[A4785K54PR785_98_60820347544]
      //ws mesg {"usr":"admin"}
      //ws mesg {"content":"temper_int = 0,000000","cmd":null,"sender":"sim_ul","recipient":"all"}
      //ws mesg {"type":"List","data":"d908_798_klkgr_ht875","
    }
    if (WS_ACTIVE) {
      if (!filterMessage(mesg.data)) {
        if (!receiveStandardMessages(mesg.data)) {
          if (!receiveCustomMessage(mesg.data)) {
            //if (mesg.data != DATA_10_ID)
               handleParseError(mesg.data)
          }
        }
      }
    }
  };





  websocket.onerror = function (event: any) {
    //console.log(`Connection error ${event}`);
    console.log("Socket error " + JSON.stringify(event));
    recordMessage("Socket error " + JSON.stringify(event));
    setConnected(false)
    //setConnected(false);
  };

}

const emit = defineEmits([
  "onConnected",
  "onJoined",
  "onMessage",
  "onWsError"
]);

function setWsError(value: boolean) {
  wsError_ = value
  emit("onWsError", value);
}

function setJoined(value: boolean) {
  emit("onJoined", value);
}

function setConnected(value: boolean) {
  connect_d = value;
  emit("onConnected", value);
}

function recordMessage(message: string) {
  const wm: WSMessage = {
    id: cntr++,
    extra: message
  }
  emit("onMessage", wm)
  // wsmesgs_.value.push(wm);
}

function open() {
  doJoin742()
}

function identify(myid: string): string {
  let status = "failed";
  try {
    if (websocket !== null && !wsError_) {
      //  websocket.send(" dremote[" + myid + "]");
      websocket.send(CMD_REMOTEA + "[" + myid + "]");
      status = "identified";
    } else {
      // wsError = true;
      setWsError(true)
      console.log("websocket not ready");
    }
  } catch (error) {
    status = "failed";
  }
  return status
}

function quit() {
  //exposed
  if (connect_d && websocket != undefined) {
    //broadcastMessage(QUIT_KEY, QUIT_CMD);
    //setJoined(false);
    //hideMe();
    if (websocket != null) {
      websocket.close();
      console.log("Disconnected from server");
    }
    setConnected(false);
    //setJoined(false);

  }
}

function sendm(m: string) {
  try {
    websocket.send(m)
  } catch (error) {
    console.log(`WS sendm error for ${m}`)
    recordMessage(`WS sendm error for ${m}`)
    //lines.value.push('ws error')
  }
}



watch(cuser, (user) => {
  if (!(user.login === '') &&
    !(user.password === '') &&
    (user.identified === true)) {
    sendUser()
  }
})

defineExpose({
  quit,
  open,
  sendm,
  identify,
  //sendUser,
});

onMounted(() => {
  // doJoin755()
  /*
    if (!WS_ON_APP) {
      doJoin742()
    }*/

  //const  wl_host = window.location.host_name
  //const socket_base = 'w_s://' + wlhost + ":" + PORT
});


onUnmounted(() => {
  //hideMe();
  //removeEventListeners();
  quit();
  //routeCb("hw remove callback", cbroutes);
});



</script>
